import * as tf from '@tensorflow/tfjs';

export function reconstructionLoss(
  original: tf.Tensor,
  reconstructed: tf.Tensor
): tf.Tensor {
  const bce = tf.mul(
    original,
    tf.log(tf.add(reconstructed, 1e-7))
  );
  const oneMinusOriginal = tf.sub(1, original);
  const logOneMinusRecon = tf.log(tf.add(tf.sub(1, reconstructed), 1e-7));
  return tf.neg(tf.mean(tf.add(bce, tf.mul(oneMinusOriginal, logOneMinusRecon))));
}

export function klLoss(mu: tf.Tensor, logVar: tf.Tensor): tf.Tensor {
  return tf.mul(
    -0.5,
    tf.sum(
      tf.add(
        tf.sub(
          tf.sub(1, tf.square(mu)),
          tf.exp(logVar)
        ),
        logVar
      ),
      -1
    )
  );
}

export function vaeLoss(
  original: tf.Tensor,
  reconstructed: tf.Tensor,
  mu: tf.Tensor,
  logVar: tf.Tensor,
  beta: number
): { loss: tf.Tensor; reconLoss: tf.Tensor; klLoss: tf.Tensor } {
  const recon = tf.mean(reconstructionLoss(original, reconstructed));
  const kl = tf.mean(klLoss(mu, logVar));
  const loss = tf.add(recon, tf.mul(beta, kl));
  return { loss, reconLoss: recon, klLoss: kl };
}
